var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('m-header', {
    attrs: {
      "title": _vm.value.title,
      "alerts": _vm.alerts,
      "breadCrumbs": _vm.breadCrumbs,
      "chips": _vm.chips,
      "actions": _vm.actions
    },
    on: {
      "actionClicked": function actionClicked($event) {
        return $event.exec();
      },
      "alertClicked": function alertClicked($event) {
        return $event.exec();
      }
    }
  }), _c('v-tabs', {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "info"
    }
  }), _c('v-tab', [_vm._v(" " + _vm._s(_vm.$t("sign.DocumentDetail.pdf")))]), _c('v-tab', [_vm._v(" " + _vm._s(_vm.$t("partner.ActivityLogTable.activity")))])], 1), _vm.isLoading ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _c('m-detail-view-grid', {
    scopedSlots: _vm._u([{
      key: "details",
      fn: function fn() {
        return [_c('m-detail-table', {
          attrs: {
            "title": _vm.$t('about'),
            "item": {
              document: _vm.value
            },
            "i18nPath": "objects",
            "config": _vm.detailTableConfig
          },
          scopedSlots: _vm._u([{
            key: "item.document.isInternal",
            fn: function fn() {
              return [_c('td', [_c('v-chip', {
                attrs: {
                  "small": ""
                }
              }, [_c('v-icon', {
                attrs: {
                  "left": "",
                  "small": ""
                }
              }, [_vm._v(" " + _vm._s(_vm.value.isInternal ? "mdi-lock-outline" : "mdi-share-variant-outline") + " ")]), _vm._v(" " + _vm._s(_vm.$t("sign.DocumentTable.".concat(_vm.value.isInternal))) + " ")], 1)], 1)];
            },
            proxy: true
          }])
        }), _vm.signature && Object.values(_vm.signature).length ? _c('m-detail-table', {
          attrs: {
            "title": _vm.$t('sign.DocumentDetail.signature'),
            "item": {
              signature: _vm.signature
            },
            "i18nPath": "objects",
            "config": _vm.signatureDetailTableConfig
          }
        }) : _vm._e(), _vm.signRequest ? _c('m-detail-table', {
          attrs: {
            "title": _vm.$t('sign.DocumentTemplateDetailSignature.signRequest'),
            "item": {
              signRequest: _vm.signRequest
            },
            "i18nPath": "objects",
            "config": _vm.signatureRequestDetailTableConfig
          }
        }) : _vm._e(), _vm.signRequests.length ? _c('div', [_c('v-subheader', {
          staticClass: "mt-2 mb-n2"
        }, [_vm._v(" " + _vm._s(_vm.$t("sign.DocumentTemplateDetailSignature.signRequest")) + " ")]), _vm._l(_vm.signRequests, function (signRequest) {
          return _c('v-card', {
            key: signRequest.id + 'sign-request-id',
            staticClass: "my-2",
            attrs: {
              "flat": ""
            }
          }, [_c('v-sheet', {
            attrs: {
              "rounded": "",
              "color": "grey lighten-4"
            }
          }, [_c('refs-sign-request', {
            attrs: {
              "item": signRequest
            },
            on: {
              "openDetail": function openDetail($event) {
                signRequest.goTo(_vm.$router).detail();
              }
            }
          })], 1)], 1);
        })], 2) : _vm._e(), _c('select-update-tags', {
          attrs: {
            "resource": _vm.ResourceEnum.DOCUMENT
          },
          model: {
            value: _vm.value,
            callback: function callback($$v) {
              _vm.value = $$v;
            },
            expression: "value"
          }
        }), _c('div', [_c('v-subheader', {
          staticClass: "mt-2 mb-n2"
        }, [_vm._v(" " + _vm._s(_vm.$t("objects.document.refs")) + " ")]), _c('refs-select', {
          ref: "refsSelect",
          attrs: {
            "partnerId": _vm.value.partnerId,
            "loading": _vm.isRefsLoading,
            "suggested": [],
            "listMode": false,
            "hideEditButton": false,
            "hideSuggestions": true,
            "confirmable": false
          },
          on: {
            "confirm": _vm.saveRefs,
            "change": _vm.saveRefs,
            "input": _vm.saveRefs
          },
          model: {
            value: _vm.value.refs,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "refs", $$v);
            },
            expression: "value.refs"
          }
        })], 1), _vm.isTpsActive && _vm.signRequest ? _c('sign-document-detail-tps', {
          attrs: {
            "document": _vm.value,
            "signatureRequest": _vm.signRequest
          }
        }) : _vm._e(), _c('shared-content-list', {
          attrs: {
            "refId": _vm.value.id,
            "partnerId": _vm.value.partnerId,
            "title": _vm.$t('clearanceApproval.shared')
          },
          on: {
            "update:sharedContent": _vm.onSharedContentUpdate
          }
        })];
      },
      proxy: true
    }, {
      key: "actions",
      fn: function fn() {
        return [_c('v-divider', {
          staticClass: "mt-6"
        }), _c('m-action-list', {
          attrs: {
            "actions": _vm.bottomActions
          },
          on: {
            "actionClicked": function actionClicked($event) {
              return $event.exec();
            }
          }
        })];
      },
      proxy: true
    }])
  }, [_c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_c('sign-document-detail-viewer', {
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1), _c('v-tab-item', [_c('activity-card', {
    attrs: {
      "partner": _vm.partner,
      "source": _vm.source,
      "config": {
        comment: true,
        mail: false
      }
    }
  })], 1)], 1)], 1), _vm.isDeleteDialogActive && _vm.value ? _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDeleteDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "title": _vm.$t('partner.PartnerReportDetailChangeProgress.confirmDeleteTitle'),
      "rightColor": 'error',
      "loading": _vm.isDeleteLoading,
      "rightLoading": _vm.isDeleteLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isDeleteDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isDeleteDialogActive = false;
      },
      "rightClick": _vm.onDelete
    }
  }) : _vm._e(), _c('document-manage-access-dialog', {
    attrs: {
      "isDialogActive": _vm.documentManageAccessDialog
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.documentManageAccessDialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.documentManageAccessDialog = $event;
      }
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }), _c('report-document-sign-request-dialog', {
    ref: "signRequestDialog",
    on: {
      "close": _vm.onCloseSignRequestDialog
    }
  }), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isUpdateDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "rightLoading": _vm.isLoading,
      "rightDisabled": !_vm.isUpdateValid,
      "title": _vm.$t('components.fleet.FleetVehicleDetailDocumentCard.editAddDocumentDialogTitle'),
      "width": "1050"
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isUpdateDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isUpdateDialogActive = $event;
      },
      "rightClick": _vm.saveUpdate,
      "leftClick": function leftClick($event) {
        _vm.isUpdateDialogActive = false;
      },
      "close": function close($event) {
        _vm.isUpdateDialogActive = false;
      }
    }
  }, [_c('sign-document-form', {
    ref: "signDocumentForm",
    attrs: {
      "isUpdate": true,
      "hideButton": true,
      "showFolder": false,
      "showIsTemplate": false,
      "isLoading": _vm.isLoading,
      "partnerId": _vm.partner.id,
      "document": _vm.value
    },
    on: {
      "save": _vm.saveUpdate,
      "updateValid": function updateValid($e) {
        return _vm.isUpdateValid = $e;
      }
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }